import React from 'react';
import { useAuth } from '../context/AuthContext';
import logoImg from '../image/logo_4.png';

const NAV = [
  { id: 'overview', icon: '⊞', label: 'Обзор'      },
  { id: 'devices',  icon: '🖨', label: 'Киоски'     },
  { id: 'stats',    icon: '▤', label: 'Статистика'  },
  { id: 'settings', icon: '⚙', label: 'Настройки'   },
  { id: 'map',      icon: '🗺', label: 'Карта'       },
];

export const MainLayout = ({ children, activeTab, setTab }) => {
  const { logout } = useAuth();

  return (
    <div className="app">
      {/* Фоновое изображение */}
      <div className="bg-image" />

      <aside className="sidebar">
        {/* Logo */}
        <div className="sidebar-logo">
          <img src={logoImg} alt="NKEY Kiosk" />
        </div>

        {/* Nav */}
        <ul className="sidebar-nav">
          {NAV.map(({ id, icon, label }) => (
            <li key={id}>
              <button
                className={`nav-item${activeTab === id ? ' active' : ''}`}
                onClick={() => setTab(id)}
              >
                <span className="nav-icon">{icon}</span>
                {label}
              </button>
            </li>
          ))}
        </ul>

        {/* Logout */}
        <div className="sidebar-footer">
          <button className="logout-btn" onClick={logout}>
            ← Выйти
          </button>
        </div>
      </aside>

      <main className="content-area">
        <div className="content-inner">
          {children}
        </div>
      </main>
    </div>
  );
};
